// Action Constants

export enum ActionConstant {
	GET_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_LIST',
	GET_KEYWORD_DATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_KEYWORD_DATA',
	GET_PROGRESS_DATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_PROGRESS_DATA',
	GET_KEYWORD_ID = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_KEYWORD_ID',
	CLEAR_KEYWORD_DATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_KEYWORD_DATA',
	GET_GENERATE_RESULT_DOCUMENT = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_GENERATE_RESULT_DOCUMENT',
	CLEAR_GENERATE_RESULT_DOCUMENT = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_GENERATE_RESULT_DOCUMENT',
	GET_TRADE = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_TRADE',
	GET_PAGE_VALUE_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_PAGE_VALUE_LIST',
	GET_PAGE_VALUE_TEXT_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_PAGE_VALUE_TEXT_LIST',
	GET_TRADE_RESULT = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_TRADE_RESULT',
	GET_TRADE_RESULT_MULTI_PACKAGE = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_TRADE_RESULT_MULTI_PACKAGE',
	GET_INTERACTIVE_RESULT = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_INTERACTIVE_RESULT',
	GET_MULTI_INTERACTIVE_RESULT = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_MULTI_INTERACTIVE_RESULT',
	GET_TRADE_RESULTDATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_TRADE_RESULTDATA',
	GET_TRADE_RESULT_COPY = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_TRADE_RESULT_COPY',
	GET_MULTI_TRADE_RESULT_COPY = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_MULTI_TRADE_RESULT_COPY',
	GET_STATUS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_STATUS',
	CLEAR_DATA_DETAILS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_DATA_DETAILS',
	GET_RECENTDOCUMENTS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_RECENTDOCUMENTS',
	GET_RECENTSPECIFICATION = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_RECENTSPECIFICATION',
	GET_SEARCHHISTORY = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_SEARCHHISTORY',
	SET_SCOPE_DOCUMENT_CHECKLIST_ROLLUPS = 'FILE://PROJECT_DETAILS_MANAGEMENT/SET_SCOPE_DOCUMENT_CHECKLIST_ROLLUPS',
	GET_SEARCHHISTORYDATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_SEARCHHISTORYDATA',
	GET_AUTOANALYSISLISTDATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_AUTOANALYSISLISTDATA',
	SET_SEARCHHISTORY_FETCHING_COMPLETE = 'FILE://PROJECT_DETAILS_MANAGEMENT/SET_SEARCHHISTORY_FETCHING_COMPLETE',
	SET_AUTOANALYSISLIST_FETCHING_COMPLETE = 'FILE://PROJECT_DETAILS_MANAGEMENT/SET_AUTOANALYSISLIST_FETCHING_COMPLETE',
	GET_DOCUMENTHISTORY = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_DOCUMENTHISTORY',
	GET_USERS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_USERS',
	GET_ALL_USERS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_ALL_USERS',
	CLEAR_DATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_DATA',
	CLEAR_SEARCHHISTORY = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_SEARCHHISTORY',
	CLEAR_AUTOANALYSISLISTDATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_AUTOANALYSISLISTDATA',

	CLEAR_DOCUMENTHISTORY = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_DOCUMENTHISTORY',
	CLEAR_USERS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_USERS',
	CLEAR_ALL_USERS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_ALL_USERS',
	CLEAR_STATUS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_STATUS',
	CLEAR_TRADE = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_TRADE',
	CLEAR_PAGE_VALUE_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_PAGE_VALUE_LIST',
	CLEAR_PAGE_VALUE_TEXT_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_PAGE_VALUE_TEXT_LIST',
	CLEAR_TRADE_RESULT = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_TRADE_RESULT',
	CLEAR_PRIOR_RESULT = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_PRIOR_RESULT',
	CLEAR_MULTI_PACKAGE_TRADE_RESULT = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_MULTI_PACKAGE_TRADE_RESULT',
	CLEAR_TRADE_RESULT_COPY = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_TRADE_RESULT_COPY',
	CLEAR_MULTI_TRADE_RESULT_COPY = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_MULTI_TRADE_RESULT_COPY',
	CLEAR_MULTI_INTERACTIVE_TRADE_RESULT = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_MULTI_INTERACTIVE_TRADE_RESULT',
	GET_DOC_TYPE = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_DOC_TYPE',
	// GET_TRADE_MOVE_COPY = 'GET_TRADE_MOVE_COPY',
	GET_SCOPE_DOCS_BY_GROUP = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_SCOPE_DOCS_BY_GROUP',
	CLEAR_SCOPE_DOCS_BY_GROUP = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_SCOPE_DOCS_BY_GROUP',
	GET_COORDINATION_DOCS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_COORDINATION_DOCS',
	CLEAR_COORDINATION_DOCS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_COORDINATION_DOCS',
	GET_ALREADY_SEARCHED_TRADES = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_ALREADY_SEARCHED_TRADES',
	CLEAR_ALREADY_SEARCHED_TRADES = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_ALREADY_SEARCHED_TRADES',
	GET_ALL_PAGES = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_ALL_PAGES',
	CLEAR_ALL_PAGES = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_ALL_PAGES',
	GENERATE_COORDINATION_DOCS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GENERATE_COORDINATION_DOCS',
	CLEAR_GENERATE_COORDINATION_DOCS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_GENERATE_COORDINATION_DOCS',
	DELETE_COORDINATION_DOC = 'FILE://PROJECT_DETAILS_MANAGEMENT/DELETE_COORDINATION_DOC',
	GET_CURRENT_DRAWINGS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_CURRENT_DRAWINGS',
	GET_CURRENT_SPECIFICATIONS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_CURRENT_SPECIFICATIONS',
	GET_SPECIFICATION_DETAILS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_SPECIFICATION_DETAILS',
	GET_SPEC_SUMMARY = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_SPEC_SUMMARY',
	CONFIRM_SPECIFICATION = 'FILE://PROJECT_DETAILS_MANAGEMENT/CONFIRM_SPECIFICATION',
	CLEAR_CURRENT_DRAWINGS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_CURRENT_DRAWINGS',
	CLEAR_CURRENT_DRAWINGS_DATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_CURRENT_DRAWINGS_DATA',
	CLEAR_CURRENT_SPECIFICATIONS_DATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_CURRENT_SPECIFICATIONS_DATA',
	CLEAR__SPECIFICATION_DETAILS_DATA = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR__SPECIFICATION_DETAILS_DATA',
	GET_SCAN_CURRENT_DRAWINGS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_SCAN_CURRENT_DRAWINGS',
	CLEAR_SCAN_CURRENT_DRAWINGS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_SCAN_CURRENT_DRAWINGS',
	GET_CHECK_NEW_DRAWINGS = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_CHECK_NEW_DRAWINGS',
	CLEAR_CHECK_NEW_DRAWINGS = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_CHECK_NEW_DRAWINGS',
	GET_DIFF_RESULT = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_DIFF_RESULT',
	SET_MAKE_CURRENT_ACTIVE = 'FILE://PROJECT_DETAILS_MANAGEMENT/SET_MAKE_CURRENT_ACTIVE',
	SET_MAKE_CURRENT_INACTIVE = 'FILE://PROJECT_DETAILS_MANAGEMENT/SET_MAKE_CURRENT_INACTIVE',
	GET_AUTO_ANALYSIS_TRADES_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_AUTO_ANALYSIS_TRADES_LIST',
	CLEAR_AUTO_ANALYSIS_TRADES_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_AUTO_ANALYSIS_TRADES_LIST',
	GET_EXCLUSIVITY_REVIEW = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_EXCLUSIVITY_REVIEW',
	CLEAR_EXCLUSIVITY_REVIEW = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_EXCLUSIVITY_REVIEW',
	SET_EXCLUSIVITY_REVIEW_FETCHING = 'FILE://PROJECT_DETAILS_MANAGEMENT/SET_EXCLUSIVITY_REVIEW_FETCHING',
	GET_BID_PACKAGES_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_BID_PACKAGES_LIST',
	CLEAR_BID_PACKAGES_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_BID_PACKAGES_LIST',
	SET_BID_PACKAGES_FETCHING_COMPLETE = 'FILE://PROJECT_DETAILS_MANAGEMENT/SET_BID_PACKAGES_FETCHING_COMPLETE',
	GET_BID_PACKAGE_AUTOSOW_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/GET_BID_PACKAGE_AUTOSOW_LIST',
	CLEAR_BID_PACKAGE_AUTOSOW_LIST = 'FILE://PROJECT_DETAILS_MANAGEMENT/CLEAR_BID_PACKAGE_AUTOSOW_LIST',
}
export interface DocLists {
	type: ActionConstant.GET_RECENTDOCUMENTS;
	count: number;
	rows: [];
}
export interface SpecLists {
	type: ActionConstant.GET_RECENTSPECIFICATION;
	count: number;
	rows: [];
}

export interface SearchHistoryLists {
	type: ActionConstant.GET_SEARCHHISTORY;
	searchHistory: [];
}
export interface SearchHistoryDatas {
	type: ActionConstant.GET_SEARCHHISTORYDATA;
	searchHistoryData: any;
}
export interface autoAnalysisListDatas {
	type: ActionConstant.GET_AUTOANALYSISLISTDATA;
	autoAnalysisListData: any;
}

export interface DocumentHistoryLists {
	type: ActionConstant.GET_DOCUMENTHISTORY;
	result: [];
}
export interface UserLists {
	type: ActionConstant.GET_USERS;
	count: number;
	rows: [];
}
export interface AllUserLists {
	type: ActionConstant.GET_ALL_USERS;
	count: number;
	rows: [];
}
export interface TradeList {
	type: ActionConstant.GET_TRADE;
	count: number;
	rows: [];
}
export interface TradeResult {
	type: ActionConstant.GET_TRADE_RESULT;
	searchResults: [];
	priorSearchResults: [];
	diffResults: [];
	bidPackageColor: string;
	scopeChecklistPatches?: any[];
}
export interface MultiPackageTradeResult {
	type: ActionConstant.GET_TRADE_RESULT_MULTI_PACKAGE;
	multiPackageSearchResults: [];
}
export interface InteractiveResult {
	type: ActionConstant.GET_INTERACTIVE_RESULT;
	interactiveResult: [];
}
export interface MultiInteractiveResult {
	type: ActionConstant.GET_MULTI_INTERACTIVE_RESULT;
	multiInteractiveResult: [];
}
export interface TradeResultData {
	type: ActionConstant.GET_TRADE_RESULTDATA;
	searchResults: [];
}
export interface TradeResultCopy {
	type: ActionConstant.GET_TRADE_RESULT_COPY;
	searchResults: [];
	priorSearchResults: [];
	diffResults: [];
	status: boolean;
	isActiveProject: boolean;
}
export interface MultiTradeResultCopy {
	type: ActionConstant.GET_MULTI_TRADE_RESULT_COPY;
	multiPackageSearchResults: [];
	status: boolean;
	isActiveProject: boolean;
}

export interface ScopeDoc {
	type: ActionConstant.GET_SCOPE_DOCS_BY_GROUP;
	searchHistory: { title: string; scopeDocuments: [] };
}

export interface CoordinationDoc {
	type: ActionConstant.GET_COORDINATION_DOCS;
	message: string;
	data: {
		rows: [];
		count: number;
	};
}

// Action Types

export interface ClearDataType {
	type: ActionConstant.CLEAR_DATA;
}
export interface ClearKeywordData {
	type: ActionConstant.CLEAR_KEYWORD_DATA;
}
export interface ClearUsersType {
	type: ActionConstant.CLEAR_USERS;
}
export interface ClearSearchHistoryType {
	type: ActionConstant.CLEAR_SEARCHHISTORY;
	requestId?: number;
	requestKey?: string;
	silent?: boolean;
}
export interface ClearAutoAnalysisListDataType {
	type: ActionConstant.CLEAR_AUTOANALYSISLISTDATA;
	requestId?: number;
	requestKey?: string;
}
export interface SetSearchHistoryFetchingComplete {
	type: ActionConstant.SET_SEARCHHISTORY_FETCHING_COMPLETE;
	requestId?: number;
	requestKey?: string;
}
export interface SetAutoAnalysisListFetchingComplete {
	type: ActionConstant.SET_AUTOANALYSISLIST_FETCHING_COMPLETE;
	requestId?: number;
	requestKey?: string;
}
export interface ClearDocumentHistoryType {
	type: ActionConstant.CLEAR_DOCUMENTHISTORY;
}
export interface ClearAllUsersType {
	type: ActionConstant.CLEAR_ALL_USERS;
}
export interface ClearTradeType {
	type: ActionConstant.CLEAR_TRADE;
}
export interface ClearPageValueListType {
	type: ActionConstant.CLEAR_PAGE_VALUE_LIST;
}
export interface ClearPageValueTextListType {
	type: ActionConstant.CLEAR_PAGE_VALUE_TEXT_LIST;
}
export interface ClearTradeResultType {
	type: ActionConstant.CLEAR_TRADE_RESULT;
}
export interface ClearPriorResultType {
	type: ActionConstant.CLEAR_PRIOR_RESULT;
}
export interface ClearMultiPackageTradeResultType {
	type: ActionConstant.CLEAR_MULTI_PACKAGE_TRADE_RESULT;
}
export interface ClearTradeResultCopyType {
	type: ActionConstant.CLEAR_TRADE_RESULT_COPY;
}
export interface ClearMultiTradeResultCopyType {
	type: ActionConstant.CLEAR_MULTI_TRADE_RESULT_COPY;
}
export interface ClearMultiInteractiveTradeResultType {
	type: ActionConstant.CLEAR_MULTI_INTERACTIVE_TRADE_RESULT;
}
export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}

export interface ClearDataDetails {
	// clear data details
	type: ActionConstant.CLEAR_DATA_DETAILS;
}
export interface ClearCurrentDrawings {
	type: ActionConstant.CLEAR_CURRENT_DRAWINGS;
}
export interface ClearGenerateResultDocumentType {
	// clear data details
	type: ActionConstant.CLEAR_GENERATE_RESULT_DOCUMENT;
}

export interface Lists {
	// details of project
	name: string;
	id: number;
	primaryContact: string;
	location: string;
	phone: string;
	startDate: string;
	email: string;
	structureType: string | null;
	skinTypes: string[];
	projectNumber?: string;
	bidsDueDate?: string;
	jobsiteAddress?: string;
	jobsiteCity?: string;
	jobsiteState?: string;
	currencyCode?: 'USD' | 'AUD' | 'EUR' | 'CAD' | 'MXN';
	visibility?: 'INVITE_ONLY' | 'DISCOVERABLE';
	client?: string;
	ndaRequired?: boolean;
	accountManagerId?: number | null;
	estimatedValue?: number | null;
	marketSector?: string;
	demolition?: boolean | null;
	elementDetermination?: {
		state: string;
		source: string | null;
		attemptCount: number;
		errorMessage: string | null;
		resolvedAt: string | null;
	};
	autoAnalysisPromptDismissedAt?: string | null;
	autoAnalysisCoachmarkShownAt?: string | null;
	autoAnalysisPackagesCreatedAt?: string | null;
	bidInvitesEnabledAt?: string | null;
	importEligible?: boolean;
	showCheckDrawings: boolean;
	specStoreStatus: string;
}
export interface PageValList {
	coordinates: [];
	name: string;
	pageNumbers: [];
	rotationAngle: [];
}
export interface PageValTextList {
	Payload: string;
}

export interface ResultDoc {
	s3PdfUrl: string;
	s3ExcelUrl: string;
}

export interface KeywordCount {
	processCount: string;
	totalCount: string;
	progressStatus?: EnumProgressStatus;
}
export interface ProgressCount {
	processCount: string;
	totalCount: string;
	progressId: number;
	progressStatus: EnumProgressStatus;
	metadata?: Record<string, any>;
	progressMetadata?: Record<string, any>;
}
export enum EnumProgressStatus {
	INPROGRESS = 'INPROGRESS',
	POST_PROCESSING = 'POST_PROCESSING',
	COORDINATING_WITH_OTHER_TRADES = 'COORDINATING_WITH_OTHER_TRADES',
	COMPLETED = 'COMPLETED',
}
export interface KeywordId {
	rowId: string;
}

export interface GetListType {
	type: ActionConstant.GET_LIST;
	data: Lists;
}
export interface GetKeyWordId {
	type: ActionConstant.GET_KEYWORD_ID;
	data: KeywordId;
}
export interface GetKeywordCountType {
	type: ActionConstant.GET_KEYWORD_DATA;
	data: KeywordCount;
}
export interface GetProgressCountType {
	type: ActionConstant.GET_PROGRESS_DATA;
	data: ProgressCount[];
}

export interface GetRecentDocumentsListType {
	type: ActionConstant.GET_RECENTDOCUMENTS;
	data: DocLists;
}

export interface GetRecentSpecificationsListType {
	type: ActionConstant.GET_RECENTSPECIFICATION;
	data: SpecLists;
}

export interface GetSearchHistoryType {
	type: ActionConstant.GET_SEARCHHISTORY;
	data: SearchHistoryLists;
	requestId?: number;
	requestKey?: string;
	silent?: boolean;
	rollupsOnly?: boolean;
}
export interface SetScopeDocumentChecklistRollups {
	type: ActionConstant.SET_SCOPE_DOCUMENT_CHECKLIST_ROLLUPS;
	projectId: number;
	rollups: any;
}
export interface GetSearchHistoryDataType {
	type: ActionConstant.GET_SEARCHHISTORYDATA;
	data: SearchHistoryDatas;
}
export interface GetAutoAnalysisListType {
	type: ActionConstant.GET_AUTOANALYSISLISTDATA;
	data: autoAnalysisListDatas;
	requestId?: number;
	requestKey?: string;
}

export interface GetDocumentHistoryType {
	type: ActionConstant.GET_DOCUMENTHISTORY;
	data: DocumentHistoryLists;
}
export interface GetUsersListType {
	type: ActionConstant.GET_USERS;
	data: UserLists;
}

export interface GetGenerateResultDocumentType {
	type: ActionConstant.GET_GENERATE_RESULT_DOCUMENT;
	data: ResultDoc;
}
export interface GetAllUsersListType {
	type: ActionConstant.GET_ALL_USERS;
	data: AllUserLists;
}
export interface GetTradeListType {
	type: ActionConstant.GET_TRADE;
	data: TradeList;
}

export interface GetTradeResultType {
	type: ActionConstant.GET_TRADE_RESULT;
	data: TradeResult;
}
export interface GetMultiPackageTradeResultType {
	type: ActionConstant.GET_TRADE_RESULT_MULTI_PACKAGE;
	data: MultiPackageTradeResult;
}
export interface GetInteractiveResultType {
	type: ActionConstant.GET_INTERACTIVE_RESULT;
	data: InteractiveResult;
}
export interface GetMultiInteractiveResultType {
	type: ActionConstant.GET_MULTI_INTERACTIVE_RESULT;
	data: MultiInteractiveResult;
}
export interface GetTradeResultDataType {
	type: ActionConstant.GET_TRADE_RESULTDATA;
	data: TradeResultData;
}
export interface GetTradeResultCopyType {
	type: ActionConstant.GET_TRADE_RESULT_COPY;
	data: TradeResultCopy;
}
export interface GetMultiTradeResultCopyType {
	type: ActionConstant.GET_MULTI_TRADE_RESULT_COPY;
	data: MultiTradeResultCopy;
}
export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}

export interface GetDocType {
	type: ActionConstant.GET_DOC_TYPE;
	docList: [];
}
export interface GetPageValueListType {
	type: ActionConstant.GET_PAGE_VALUE_LIST;
	data: PageValList;
}
export interface GetPageValueTextListType {
	type: ActionConstant.GET_PAGE_VALUE_TEXT_LIST;
	data: PageValTextList;
}

export interface GetScopeDocsType {
	type: ActionConstant.GET_SCOPE_DOCS_BY_GROUP;
	data: ScopeDoc;
}
export interface ClearScopeDocsType {
	type: ActionConstant.CLEAR_SCOPE_DOCS_BY_GROUP;
}

export interface GetCoordinationDocsType {
	type: ActionConstant.GET_COORDINATION_DOCS;
	data: CoordinationDoc;
}
export interface ClearCoordinationDocsType {
	type: ActionConstant.CLEAR_COORDINATION_DOCS;
}

export interface GetAlreadySearchedTrades {
	type: ActionConstant.GET_ALREADY_SEARCHED_TRADES;
	data: any;
}
export interface ClearAlreadySearchedTrades {
	type: ActionConstant.CLEAR_ALREADY_SEARCHED_TRADES;
}

export interface GetAllPages {
	type: ActionConstant.GET_ALL_PAGES;
	data: any;
}
export interface ClearAllPages {
	type: ActionConstant.CLEAR_ALL_PAGES;
}

export interface GenerateCoordinationMarkup {
	type: ActionConstant.GENERATE_COORDINATION_DOCS;
	data: any;
}
export interface ClearGenerateCoordinationMarkup {
	type: ActionConstant.CLEAR_GENERATE_COORDINATION_DOCS;
}

export interface GetCurrentDrawings {
	type: ActionConstant.GET_CURRENT_DRAWINGS;
	data: [];
}
export interface GetCurrentSpecifications {
	type: ActionConstant.GET_CURRENT_SPECIFICATIONS;
	data: [];
}
export interface GetSpecificationDetails {
	type: ActionConstant.GET_SPECIFICATION_DETAILS;
	data: [];
}
export interface GetSpecSummary {
	type: ActionConstant.GET_SPEC_SUMMARY;
	data: any;
}
export interface ConfirmSpecification {
	type: ActionConstant.CONFIRM_SPECIFICATION;
}
export interface ClearCurrentSpecificationsData {
	type: ActionConstant.CLEAR_CURRENT_SPECIFICATIONS_DATA;
}
export interface ClearSpecificationDetailsData {
	type: ActionConstant.CLEAR__SPECIFICATION_DETAILS_DATA;
}
export interface ClearCurrentDrawingsData {
	type: ActionConstant.CLEAR_CURRENT_DRAWINGS_DATA;
}

export interface ScanCurrentDrawings {
	type: ActionConstant.GET_SCAN_CURRENT_DRAWINGS;
	data: [];
}

export interface ClearScanCurrentDrawings {
	type: ActionConstant.CLEAR_SCAN_CURRENT_DRAWINGS;
}

export interface CheckForNewDrawings {
	type: ActionConstant.GET_CHECK_NEW_DRAWINGS;
	data: [];
}

export interface ClearCheckForNewDrawings {
	type: ActionConstant.CLEAR_CHECK_NEW_DRAWINGS;
}
export interface GetDiffResultType {
	type: ActionConstant.GET_DIFF_RESULT;
	diffResults: [];
	diffResultsCopy: [];
}
export interface SetMakeCurrentActive {
	type: ActionConstant.SET_MAKE_CURRENT_ACTIVE;
}

export interface SetMakeCurrentInactive {
	type: ActionConstant.SET_MAKE_CURRENT_INACTIVE;
}

export interface GetAutoAnalysisTrades {
	type: ActionConstant.GET_AUTO_ANALYSIS_TRADES_LIST;
	data: {
		data: {
			finalData: [];
		};
		canAutoAnalyze: boolean;
		remainingTimeMs: number;
	};
}

export interface ClearAutoAnalysisTrades {
	type: ActionConstant.CLEAR_AUTO_ANALYSIS_TRADES_LIST;
}
export interface ExclusivityReviewData {
	totalHits: number;
	pages: any[];
	hits: any[];
}
export interface GetExclusivityReview {
	type: ActionConstant.GET_EXCLUSIVITY_REVIEW;
	data: ExclusivityReviewData;
}
export interface ClearExclusivityReview {
	type: ActionConstant.CLEAR_EXCLUSIVITY_REVIEW;
}
export interface SetExclusivityReviewFetching {
	type: ActionConstant.SET_EXCLUSIVITY_REVIEW_FETCHING;
}

export interface GetBidPackagesList {
	type: ActionConstant.GET_BID_PACKAGES_LIST;
	data: any[];
	projectId?: number;
	receivedAt?: number;
	requestId?: number;
}

export interface ClearBidPackagesList {
	type: ActionConstant.CLEAR_BID_PACKAGES_LIST;
	projectId?: number;
	requestId?: number;
}

export interface SetBidPackagesFetchingComplete {
	type: ActionConstant.SET_BID_PACKAGES_FETCHING_COMPLETE;
	projectId: number;
	requestId: number;
}

export interface GetBidPackageAutoSOWList {
	type: ActionConstant.GET_BID_PACKAGE_AUTOSOW_LIST;
	data: [];
}

export interface ClearBidPackageAutoSOWList {
	type: ActionConstant.CLEAR_BID_PACKAGE_AUTOSOW_LIST;
}

export type ActionType =
	| GetListType
	| GetKeywordCountType
	| GetProgressCountType
	| GetKeyWordId
	| GetRecentDocumentsListType
	| GetRecentSpecificationsListType
	| GetUsersListType
	| GetStatusType
	| ClearKeywordData
	| ClearDataType
	| ClearDataDetails
	| GetTradeListType
	| ClearStatusType
	| ClearTradeType
	| GetDocType
	| GetTradeResultType
	| GetMultiPackageTradeResultType
	| GetInteractiveResultType
	| GetMultiInteractiveResultType
	| GetTradeResultDataType
	| GetTradeResultCopyType
	| GetMultiTradeResultCopyType
	| ClearTradeResultType
	| ClearPriorResultType
	| ClearMultiPackageTradeResultType
	| ClearTradeResultCopyType
	| ClearMultiTradeResultCopyType
	| ClearMultiInteractiveTradeResultType
	| ClearUsersType
	| ClearAllUsersType
	| GetAllUsersListType
	| GetGenerateResultDocumentType
	| ClearGenerateResultDocumentType
	| GetSearchHistoryType
	| SetScopeDocumentChecklistRollups
	| GetSearchHistoryDataType
	| GetAutoAnalysisListType
	| GetDocumentHistoryType
	| ClearSearchHistoryType
	| ClearAutoAnalysisListDataType
	| SetSearchHistoryFetchingComplete
	| SetAutoAnalysisListFetchingComplete
	| ClearDocumentHistoryType
	| GetPageValueListType
	| ClearPageValueListType
	| GetPageValueTextListType
	| ClearPageValueTextListType
	| GetScopeDocsType
	| ClearScopeDocsType
	| GetCoordinationDocsType
	| ClearCoordinationDocsType
	| GetAlreadySearchedTrades
	| ClearAlreadySearchedTrades
	| GetAllPages
	| ClearAllPages
	| GenerateCoordinationMarkup
	| ClearGenerateCoordinationMarkup
	| GetCurrentDrawings
	| GetCurrentSpecifications
	| GetSpecificationDetails
	| GetSpecSummary
	| ConfirmSpecification
	| ClearSpecificationDetailsData
	| ClearCurrentDrawings
	| ClearCurrentDrawingsData
	| ClearCurrentSpecificationsData
	| ScanCurrentDrawings
	| ClearScanCurrentDrawings
	| CheckForNewDrawings
	| ClearCheckForNewDrawings
	| GetDiffResultType
	| SetMakeCurrentActive
	| SetMakeCurrentInactive
	| GetAutoAnalysisTrades
	| ClearAutoAnalysisTrades
	| GetExclusivityReview
	| ClearExclusivityReview
	| SetExclusivityReviewFetching
	| GetBidPackagesList
	| ClearBidPackagesList
	| SetBidPackagesFetchingComplete
	| GetBidPackageAutoSOWList
	| ClearBidPackageAutoSOWList;

// State Types

export interface InitialState {
	initialList: boolean;
	keywordCountData: KeywordCount;
	ProgressCountData: ProgressCount[];
	keywordId: KeywordId;
	fetching: boolean;
	detailsFetching: boolean;
	tradeFetching: boolean;
	list: Lists;
	statusCode: number;
	noOfResults: number;
	totalResults: number;
	documentcount: number;
	specCount: number;
	recentdocuments: [];
	recentSpecifications: [];
	searchhistory: any[];
	searchhistoryByRequestKey: { [key: string]: any[] };
	searchhistoryRequestIds: { [key: string]: number };
	searchhistoryRequestKey: string | null;
	scopeDocumentChecklistProjectRollups: {
		projectId: number;
		rollups: any;
	};
	searchhistorydata: any;
	documenthistory: [];
	count: number;
	tradecount: number;
	tradelist: [];
	docList: [];
	traderesult: [];
	revisionScopeChecklistPatches: any[];
	priortraderesult: [];
	diffresult: [];
	multitraderesult: [];
	interactiveresult: [];
	multiinteractiveresult: [];
	traderesultdata: [];
	traderesultcount: number;
	traderesultFetching: boolean;
	traderesultcopy: [];
	priortraderesultcopy: [];
	diffresultcopy: [];
	multitraderesultcopy: [];
	traderesultFetchingcopy: boolean;
	users: [];
	usercount: number;
	userFetching: boolean;
	allusers: [];
	allusercount: number;
	alluserFetching: boolean;
	generatetraderesult: ResultDoc;
	generatetraderesultFetching: boolean;
	searchhistoryFetching: boolean;
	documenthistoryFetching: boolean;
	pagevaluelist: PageValList;
	pagevaluetextlist: PageValTextList;
	pageValueFetching: boolean;
	tradeResultStatus: boolean;
	isActiveProject: boolean;
	scopeDocumentsArrayByTrade: { searchHistory: { title: string; scopeDocuments: [] } };
	coordinationDocuments: { count: number; rows: [] };
	coordinationDocumentsFetching: boolean;
	alreadySearchedTradesList: [];
	alreadySearchedTradesListFetching: boolean;
	allPagesList: [];
	allPagesFetching: boolean;
	coordinationMarkupGenerating: boolean;
	coordinationMarkup: {
		coordinationMarkupUrl: string;
		message?: string;
		status: string;
	};
	currentDrawingsFetching: boolean;
	currentDrawings: [];
	currentSpecifications: [];
	currentSpecificationsFetching: boolean;
	specificationDetails: any;
	specificationDetailsFetching: boolean;
	specSummary: any[];
	scanCurrentDrawingsResult: [];
	scanCurrentDrawingsFetching: boolean;
	ClearScanCurrentDrawings: [];
	checkNewDrawingsResult: [];
	checkNewDrawingsResultFetching: boolean;
	isMakeCurrentActive: boolean;
	autoAnalysisTrades: [];
	autoAnalysisTradesFetching: boolean;
	autoAnalysisListData: any[];
	autoAnalysisListFetching: boolean;
	autoAnalysisListByRequestKey: { [key: string]: any[] };
	autoAnalysisListRequestIds: { [key: string]: number };
	autoAnalysisListRequestKey: string | null;
	canAutoAnalyze: boolean;
	remainingTimeMs: number; // Elastic search ingestion time remaining
	exclusivityReviewData: ExclusivityReviewData;
	exclusivityReviewFetching: boolean;
	bidPackagesFetching: boolean;
	bidPackages: any[];
	bidPackageColor: string;
	bidPackageAutoSOWList: [];
	bidPackagesByProjectId: { [key: string]: any[] };
	bidPackagesProjectId: number;
	bidPackagesRequestIds: { [key: string]: number };
	bidPackagesUpdatedAtByProjectId: { [key: string]: number };
	bidPackageAutoSOWListFetching: boolean;
}
